module.exports = __webpack_public_path__ + "media/images/posts/comics-b24f8f9e521b15dedd8b1de5c333d900.jpg";